<template>
  <v-row justify="center" no-gutters style="position: relative; height: 130px;">
    <v-img height="130" src="@/assets/images/top_bar.svg" style="position: absolute;" width="100%"></v-img>
    <v-col cols="4">
      <slot name="logos"></slot>
    </v-col>
    <v-col cols="4">
      <div class="text-center text-capitalize title font-weight-thin white--text pt-9">
        <slot name="title"></slot>
      </div>
    </v-col>
    <v-col cols="4">
      <slot name="info"></slot>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: "TopBar",
  components: {
  },
}
</script>

<style scoped>
</style>